module.exports = __webpack_public_path__ + "img/success-1.18fe2ecc.svg";